// src/components/common/ZoomChartModal.tsx
import React from "react";
import PrismaZoom from "react-prismazoom";
import "./zoomable-image.scss"; // create this for styling

interface ZoomChartModalProps {
  imageSrc: string;
  onClose: () => void;
}

const ZoomChartModal: React.FC<ZoomChartModalProps> = ({ imageSrc, onClose }) => {
  return (
    <div className="zoom-chart-modal">
      <button className="zoom-close-btn" onClick={onClose}>×</button>
      <PrismaZoom>
        <img src={imageSrc} alt="Zoomable Chart" className="zoom-chart-image" />
      </PrismaZoom>
    </div>
  );
};

export default ZoomChartModal;
